<template>
  <div class="survey-cake-page" :class="{ 'pdf-mode': isPDF }">
    <img src="@/assets/survey-cake/logo.png" class="logo" />
    <div class="class-page">
      <div class="page-title">
        <img src="@/assets/survey-cake/star-icon.png" class="star-icon" />
        <h3 class="GenSenRounded">在這次 DFC 行動中，看見自己的超能力</h3>
      </div>
      <div class="class-contain">
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-music-title.png"
                class="class-icon"
              />
              <div class="class-title-text">音樂智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("音樂智能").total >= 22
                  ? "你很會用音樂來表達想法、帶動氣氛。在報告時，你還會調整自己聲音的高低和語調，讓大家聽得更投入。"
                  : "你比較少用音樂或節奏來表達想法，不過平常你在聽音樂或唱歌時，其實已經在展現音樂超能力，只是還沒完全在這次行動中發揮出來。"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-red.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("音樂智能").total >= 22
                  ? "下次挑戰創作一小段旋律或音效，放在影片裡或分享活動中，用你的音樂超能力帶給大家驚喜吧！"
                  : "下次在發想點子時，可以放自己喜歡的音樂，讓旋律陪著你思考，說不定就會突然蹦出新的靈感唷！"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-self-title.png"
                class="class-icon"
              />
              <div class="class-title-text">內省智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("內省智能").total >= 22
                  ? "你很常思考自己做得好的地方是什麼、還有哪裡能做得更好。你的內省超能力不只讓你更了解自己，也會讓你越來越進步。"
                  : "這次你可能更專注在實踐點子，比較少花時間思考自己在過程中的心情，但只要多練習，你的內省超能力會讓你更了解自己唷！"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-orange.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("內省智能").total >= 22
                  ? "試著幫自己設定在學校想達成的小目標，紀錄自己每天是否離這個目標更近唷！"
                  : "每天試著花五分鐘靜下來，寫下一件覺得自己做的很棒的事情，或是讓你感到開心的事情吧！"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-limbs-title.png"
                class="class-icon"
              />
              <div class="class-title-text">肢體動覺智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("肢體動覺智能").total >= 22
                  ? "你常常運用手勢或肢體語言，讓大家更了解你的想法，有時候你也會動手做道具或模型，把腦中的點子變成真的。"
                  : "你比較少用手勢或肢體語言來表達自己的想法，或是參與道具模型的製作，不過，只要你願意嘗試，你的肢體超能力就會慢慢展現出來。"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-green.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("肢體動覺智能").total >= 22
                  ? "繼續發揮你的肢體超能力，下次報告時試著加上肢體表演，讓大家更投入吧！"
                  : "下次報告時，試著加上手勢，例如用手指著重點，你會發現觀眾會更快了解，也更容易跟上你的分享唷！"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-interpersonal-title.png"
                class="class-icon"
              />
              <div class="class-title-text">人際智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("人際智能").total >= 22
                  ? "謝謝你總是用溫暖的態度和大家互動，在團隊合作中也會鼓勵同學、主動幫助他們，帶動大家一起順利完成任務。"
                  : "你可能比較習慣自己獨立完成任務，或是因為害羞，比較少和其他人互動。期待未來你能慢慢練習，發揮隱藏的人際超能力。"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-blue.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("人際智能").total >= 22
                  ? "下次試著關心心情不好的同學、或是邀請較少發言的同學加入討論，繼續運用你的人際超能力，讓大家都能更樂在其中。"
                  : "下次試著在小組討論時主動發言，或練習和旁邊的同學分享你的點子，你會發現一起討論，能激發更多想法唷！"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntelligenceSecondCard",
  props: {
    resultScore: {
      type: Array,
      required: true,
    },
    isPDF: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getScoreByName(name) {
      const scoreItem = this.resultScore.find((item) => item.name === name);
      return scoreItem || { total: 0 };
    },
  },
};
</script>

<style scoped lang="scss">
.survey-cake-page {
  width: 100vw;
  height: calc((3508 / 2480) * 100vw);
  background-color: #fae4cb;
  position: relative;
  padding: 5.8% 11.3% 7.2%;
  .logo {
    position: absolute;
    top: 2%;
    right: 3%;
    width: 4.5%;
  }
  .class-page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .page-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 2%;
  }
  .star-icon {
    width: 4.4%;
    margin-right: 1.5%;
  }
  h3 {
    color: #eb6165;
    font-size: 2.7vw;
    font-weight: 700;
    line-height: 1.2;
  }
  .class-contain {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .class-card {
    width: 100%;
    background-color: #fff;
    border-radius: 3.2vw;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .class-top {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 2% 8%;
  }
  .class-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      margin-bottom: 0.5rem;
    }
  }
  .class-icon {
    width: 2.5vw;
    margin-right: 0.5rem;
  }
  .class-title-text {
    font-size: 2vw;
    font-weight: 700;
    line-height: 1;
  }
  .class-card:nth-child(1) .class-title-text {
    color: #eb6165;
  }
  .class-card:nth-child(2) .class-title-text {
    color: #ea953a;
  }
  .class-card:nth-child(3) .class-title-text {
    color: #98ad44;
  }
  .class-card:nth-child(4) .class-title-text {
    color: #60abbc;
  }
  .class-text {
    color: #1e1e1e;
    font-size: 2vw;
    font-weight: 400;
    line-height: 2;
  }
  .class-bottom {
    position: relative;
    padding: 2% 8%;
  }
  .class-card:nth-of-type(1) .class-bottom {
    background-color: #faf1f1;
  }
  .class-card:nth-of-type(2) .class-bottom {
    background-color: #fdf4de;
  }
  .class-card:nth-of-type(3) .class-bottom {
    background-color: #fafbef;
  }
  .class-card:nth-of-type(4) .class-bottom {
    background-color: #eef7fa;
  }
  .bulb-icon {
    width: 1.7vw;
    position: absolute;
    top: 17%;
    left: 4%;
  }
  .info {
    color: #727171;
    font-size: 2vw;
    font-weight: 400;
    line-height: 2;
  }
}
.survey-cake-page.pdf-mode {
  width: 2480px;
  height: 3508px;
  h3 {
    font-size: 67px;
  }
  .class-card {
    border-radius: 80px;
  }
  .class-icon {
    width: 63px;
    margin-right: 1.5rem;
  }
  .class-title-text {
    font-size: 50px;
  }
  .class-text {
    font-size: 50px;
  }
  .bulb-icon {
    width: 40px;
    top: 20%;
  }
  .info {
    font-size: 50px;
  }
}
</style>
